import { Component, OnInit,  } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

// Service
import { GlobalService } from '../../shared/service/global.service';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styles: [
  ]
})
export class PageNotFoundComponent implements OnInit {
  
  error;

  constructor(private activedRoute: ActivatedRoute, private globalService: GlobalService) { 
    this.globalService.isLoading.next(false);
  }

  ngOnInit(): void {
    this.activedRoute.data.subscribe(
      (data: Data) => {
        this.error = data['status'];
      }
    );

    // Meta
    this.globalService.updateMeta(
      'Prime Agri Resources',
      'Prime Agri Resources',
      'Prime Agri Resources'
    );
  }

}
